import React from "react";
import SEO from "../components/SEO";

const Sell = () => {
  return (
    <>
      <SEO
        title='Sell'
        description='Shirts Patches'
        keywords='Shirts Patches'
      />
      <div className="relative bg-gradient-to-br from-green-50 via-white to-green-100 min-h-screen">
        {/* Decorative Blobs */}
        <div className="absolute top-0 left-0 w-72 h-72 bg-[#369a74]/20 rounded-full blur-3xl -z-10" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#369a74]/20 rounded-full blur-3xl -z-10" />

        <div className="container mx-auto px-4 py-20 max-w-5xl">
          {/* Header */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-extrabold text-[#369a74]">
              Do Not Sell or Share My Personal Information
            </h1>
            <p className="mt-4 text-gray-700 max-w-3xl mx-auto text-lg leading-relaxed">
              Learn about your privacy rights and how to opt-out of sharing personal information.
            </p>
          </div>

          {/* Content Card */}
          <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-gray-200 p-8 md:p-12 space-y-12">
            {[
              {
                title: "Introduction",
                content: (
                  <p>
                    At <span className="font-semibold">Personalised Patches for Hats</span>, we collect personal data through your interaction with our website and services, including the use of cookies and similar technologies.
                    This data may be shared with trusted third-party partners, including advertising providers, to deliver personalized ads on other websites, as outlined in our Privacy Policy.
                  </p>
                ),
              },
              {
                title: "Legal Explanation",
                content: (
                  <p>
                    Depending on your location, certain privacy laws may define the sharing of personal information for targeted advertising across websites as a “sale,” “sharing,” or “targeted advertising.”
                    You may have the right to opt out of these activities if you are located in an eligible jurisdiction.
                  </p>
                ),
              },
              {
                title: "How to Opt-Out",
                content: (
                  <>
                    <p className="mb-4">
                      To opt out of the “sale” or “sharing” of your personal information collected via cookies or other device-based identifiers, you must be accessing the website from an eligible U.S. state.
                    </p>
                    <p>
                      You can exercise your opt-out rights by following the instructions provided on our website or by contacting our support team directly.
                    </p>
                  </>
                ),
              },
            ].map((section, idx) => (
              <section
                key={idx}
                className="relative pl-6 group hover:bg-[#369a74]/10 transition-all duration-300 rounded-xl p-4"
              >
                <div className="absolute left-0 top-2 h-full w-1 rounded-full bg-gradient-to-b from-[#369a74] to-[#32c499] group-hover:scale-110 transition-transform" />
                <h2 className="text-2xl font-bold text-[#369a74] mb-4">
                  {section.title}
                </h2>
                <div className="text-gray-700 leading-relaxed text-base">
                  {section.content}
                </div>
              </section>
            ))}

            {/* Contact */}
            <section className="border-t pt-8 text-center">
              <h2 className="text-2xl font-bold text-[#369a74] mb-4">
                Contact Us
              </h2>
              <p className="text-gray-700 mb-4">
                If you have any questions about your privacy rights or how to opt-out, please contact us:
              </p>
              <div className="mt-4 text-gray-700">
                <p className="font-semibold text-[#369a74]">Personalised Patches for Hats</p>
                <p>Email: support@personalisedpatchesforhats.com</p>
                <p>Phone: (703) 666-8193</p>
              </div>
            </section>

            {/* Footer */}
            <p className="text-sm text-gray-500 text-center pt-6 border-t">
              Last updated: 07/08/2025
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sell;
